module.exports = {"340421100":"城关镇","340421102":"新集镇","340421103":"朱马店镇","340421104":"岳张集镇","340421105":"顾桥镇","340421106":"毛集镇","340421107":"夏集镇","340421108":"桂集镇","340421109":"焦岗湖镇","340421110":"凤凰镇","340421111":"杨村镇","340421112":"丁集镇","340421113":"刘集镇","340421114":"大兴镇","340421115":"尚塘镇","340421204":"古店乡","340421205":"钱庙乡","340421209":"关店乡","340421212":"李冲回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340421.json
// module id = 1178
// module chunks = 0